import React, { FC } from "react";

import { ArrowRightIcon } from "application/assets";

import { BannerProps } from "./models";
import { Wrapper } from "./styles";

const ShareDealBanner: FC<BannerProps> = ({ onClick }) => {
  return (
    <Wrapper>
      <p>
        Share this deal — get <span>$100</span> bonus!
      </p>
      <button type="button" onClick={onClick}>
        <ArrowRightIcon />
      </button>
    </Wrapper>
  );
};

export default ShareDealBanner;
